var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-book-comments-count label label-sm label-round"},[_c('DuiIconBalloon'),_vm._v(" "),_c('span',{staticClass:"space-left-1em valign-middle"},[_vm._v(_vm._s(_vm.bookCommentsCount))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }